import {
  trackingAllowed,
  analyticsAvailable,
  EVENT_TRACKING_STORAGE_KEY as STORAGE_KEY,
  identifier,
} from '../'
import { setItem } from '../storage'

export const track = async (handle, payload) => {
  if (trackingAllowed() && analyticsAvailable()) {
    global.analytics.track(handle, { ...payload, ...identifier })
  } else {
    setItem(STORAGE_KEY, { handle, payload })
  }
}
